module.exports = __webpack_public_path__ + "img/ltkmidsize-2x.75d75b1.jpg";